"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Holds report view styles
 */
var ReportViewStyles = /** @class */ (function () {
    function ReportViewStyles(_title, _subTitle, _header, _footer, _rowBranchStylesDto, _columnBranchStylesDto) {
        this._title = _title;
        this._subTitle = _subTitle;
        this._header = _header;
        this._footer = _footer;
        this._rowBranchStylesDto = _rowBranchStylesDto;
        this._columnBranchStylesDto = _columnBranchStylesDto;
    }
    Object.defineProperty(ReportViewStyles.prototype, "title", {
        get: function () {
            return this._title;
        },
        set: function (title) {
            this._title = title;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReportViewStyles.prototype, "subTitle", {
        get: function () {
            return this._subTitle;
        },
        set: function (_subTitle) {
            this._subTitle = _subTitle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReportViewStyles.prototype, "header", {
        get: function () {
            return this._header;
        },
        set: function (_header) {
            this._header = _header;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReportViewStyles.prototype, "footer", {
        get: function () {
            return this._footer;
        },
        set: function (_footer) {
            this._footer = _footer;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReportViewStyles.prototype, "rowBranchStylesDto", {
        get: function () {
            return this._rowBranchStylesDto;
        },
        set: function (_rowBranchStylesDto) {
            this._rowBranchStylesDto = _rowBranchStylesDto;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReportViewStyles.prototype, "columnBranchStylesDto", {
        get: function () {
            return this._columnBranchStylesDto;
        },
        set: function (_columnBranchStylesDto) {
            this._columnBranchStylesDto = _columnBranchStylesDto;
        },
        enumerable: true,
        configurable: true
    });
    ReportViewStyles.createReportViewStyles = function () {
        return new ReportViewStyles();
    };
    ReportViewStyles.prototype.toJsonObject = function () {
        return {
            title: this.title ? this.title.toJsonObject() : this.title,
            subTitle: this._subTitle ? this._subTitle.toJsonObject() : this._subTitle,
            header: this._header ? this._header.toJsonObject() : this._header,
            footer: this._footer ? this._footer.toJsonObject() : this._footer,
            rowBranchStylesDto: this._rowBranchStylesDto.map(function (v) {
                return v.toJsonObject();
            }),
            columnBranchStylesDto: this._columnBranchStylesDto.map(function (v) {
                return v.toJsonObject();
            })
        };
    };
    return ReportViewStyles;
}());
exports.ReportViewStyles = ReportViewStyles;
//# sourceMappingURL=report-view-styles.js.map